
export const updateJobNotifications = (jobNotifications) => (dispatch) => {
  dispatch({
    type: 'UPDATE_JOB_NOTIFICATIONS',
    response: { jobNotifications }
  })
}